import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalRequestAccess: ExperimentalMutations['experimentalRequestAccess'] = (
	_,
	{ contentId, accessType },
	{ network },
) =>
	fetchJSON(
		network,
		`/wiki/rest/request-access/latest/page/restriction/${contentId}/request/${accessType}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		},
	).then(
		/* onFulfilled */ (result) => ({
			complete: true,
			fullName: result.fullName,
		}),
		/* onRejected */ () => ({ complete: false, fullName: null }),
	);
